module.exports = __webpack_public_path__ + "components/rewards/freefloski/static/logo-4193232002d77c2912101de81d0ba5c1.jpg";